import { render, staticRenderFns } from "./Volunteerlist.vue?vue&type=template&id=41921f1e&scoped=true"
import script from "./Volunteerlist.vue?vue&type=script&lang=js"
export * from "./Volunteerlist.vue?vue&type=script&lang=js"
import style0 from "./Volunteerlist.vue?vue&type=style&index=0&id=41921f1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41921f1e",
  null
  
)

export default component.exports